import type { FaireProductEntity } from "../../entity_types/product";

export const p_a95gv3bbs4: FaireProductEntity = {
  token: "p_a95gv3bbs4",
  type: "product",
  name: "Happy Plaid Covered Weekly Planner",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/ca3805398b8bc839fbf2de324ac1bc08ba3f8c2331efcee2a5b12903552b3d1e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8f8bcab47cb3324853115aae531e6683d6d21d35254f80c464e275000c23c4bf.jpeg",
    "https://cdn.faire.com/fastly/09bfc367715f1490baf8c0ac4438a861841d801a1eb77ce27d52b12af6a110e9.jpeg",
    "https://cdn.faire.com/fastly/47ec63af6525379a4267ac1c512a6525ecc01deb98309c85160dbb22f603be16.jpeg",
  ],
  priceDollars: 11,
  description:
    "Some things just need to be concealed... junk drawers, those metal fin things in baseboard heaters, and messy weekly calendars! Cover that stuff up!\n\nCovered, tear-off Notepad. 52 undated, tear-off pages for each week of the year, adding a little delight to the daily routine.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:27.535Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
